
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[post-id]",
      function () {
        return require("private-next-pages/blog/[post-id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[post-id]"])
      });
    }
  